export default {
    dashboard: "Dashboard",
    currentPassword: "Current Password",
    password: "Password",
    confirmPassword: "Confirm Password",
    username: "Username",
    firstName: "First Name",
    lastName: "Last Name",
    name: "Name",
    contact: "Contact",
    email: "Email",
    description: "Description",
    companyName: "Company Name",
    company: "Company",
    address: "Address",
    address1: "Address #1",
    address2: "Address #2",
    country: "Country",
    state: "State",
    area: "Area",
    postcode: "Postcode",
    location: "Location",
    toLocation: "To Location",
    supplier: "Supplier",
    items: "Items",
    summary: "Summary",
    destination: "Destination",
    repositoryNo: "Respository No.",
    alternativeNo: "Alternative No.",
    status: "Status",
    remark: "Remark",
    type: "Type",
    updatePassword: "Update Password",
    branch: "Branch",
    documentDate: "Document Date",
    documentNumber: "Document Number",
    docNo: "Doc No.",
    dateTime: "Date Time",
    youHaveNotCreatedAnyItemYet: "You have not created any item yet.",
    youHaveNotSelectAnyItem: "You have not select any item",
    youHaveNotSelectAnyParentCategory: "You have not select any parent category.",
    previewPDF: "Preview PDF",

    weeklySales: "Weekly Sales",
    newUsers: "New Users",
    itemOrders: "Item Orders",
    bugReports: "Bug Reports",

    // ---------Page Title--------
    hiWelcomeBack: "Hi, Welcome back",
    websiteVisits: "Website Visits",
    administrators: "Administrators",
    newAdministrator: "New Administrator",
    updateAdministrator: "Update Administrator",
    customers: "Customers",
    newCustomer: "New Customer",
    updateCustomer: "Update Customer",
    suppliers: "Suppliers",
    newSupplier: "New Supplier",
    updateSupplier: "Update Supplier",
    retailers: "Retailers",
    newRetailer: "New Retailer",
    updateRetailer: "Update Retailer",
    drivers: "Drivers",
    newDriver: "New Driver",
    updateDriver: "Update Driver",
    workers: "Workers",
    newWorker: "New Worker",
    updateWorker: "Update Worker",
    products: "Products",
    newProduct: "New Product",
    viewProduct: "View Product",
    categories: "Product Categories",
    newCategory: "New Category",
    updateCategory: "Update Category",
    brands: "Brands",
    newBrand: "New Brand",
    updateBrand: "Update Brand",
    uoms: "Uoms",
    newUom: "New Uom",
    updateUom: "Update Uom",
    salesOrders: "Sales Orders",
    newSalesOrder: "New Sales Order",
    updateSalesOrder: "Update Sales Order",
    viewSalesOrder: "View Sales Order",
    proformaSales: "Proforma Sales",
    newProformaSales: "New Proforma Sales",
    updateProformaSales: "Update Proforma Sales",
    viewProformaSales: "View Proforma Sales",
    salesInvoices: "Sales Invoices",
    newSalesInvoice: "New Sales Invoice",
    updateSalesInvoice: "Update Sales Invoice",
    deliveryOrders: "Delivery Orders",
    newDeliveryOrder: "New Delivery Order",
    updateDeliveryOrder: "Update Delivery Order",
    verifyOut: "Verify Out",
    verifyIn: "Verify In",
    verifyTransferIn: "Verify Transfer In",
    verifyTransferOut: "Verify Transfer Out",
    cashSales: "Cash Sales",
    newCashSale: "New Cash Sales",
    updateCashSale: "Update Cash Sales",
    salesDebitNotes: "Sales Debit Notes",
    newSalesDebitNote: "New Sales Debit Note",
    updateSalesDebitNote: "Update Sales Debit Note",
    salesCreditNotes: "Sales Credit Notes",
    newSalesCreditNote: "New Sales Credit Note",
    updateSalesCreditNote: "Update Sales Credit Note",
    replacementDelivery: "Replacement Delivery",
    replacementDeliveries: "Replacement Deliveries",
    newReplacementDelivery: "New Replacement Delivery",
    updateReplacementDelivery: "Update Replacement Delivery",
    retailCashSales: "Retail Cash Sales",
    newRetailCashSale: "New Retail Cash Sale",
    updateRetailCashSale: "Update Retail Cash Sale",
    stockPost: "Stock Post",

    purchaseOrders: "Purchase Orders",
    newPurchaseOrder: "New Purchase Order",
    updatePurchaseOrder: "Update Purchase Order",
    purchaseReturns: "Purchase Returns",
    newPurchaseReturn: "New Purchase Return",
    updatePurchaseReturn: "Update Purchase Return",
    purchaseInvoices: "Purchase Invoices",
    newPurchaseInvoice: "New Purchase Invoice",
    updatePurchaseInvoice: "Update Purchase Invoice",

    itemReceives: "Item Receives",
    newItemReceive: "New Item Receive",
    updateItemReceive: "Update Item Receive",
    itemTransfers: "Item Transfers",
    newItemTransfer: "New Item Transfer",
    updateItemTransfer: "Update Item Transfer",
    itemRelocates: "Item Relocates",
    newItemRelocate: "New Item Relocate",
    updateItemRelocate: "Update Item Relocate",
    itemTransforms: "Item Transforms",
    newItemTransform: "New Item Transform",
    updateItemTransform: "Update Item Transform",
    itemIssues: "Item Issues",
    newItemIssue: "New Item Issue",
    updateItemIssue: "Update Item Issue",
    itemAdjustments: "Item Adjustments",
    newItemAdjustment: "New Item Adjustment",
    updateItemAdjustment: "Update Item Adjustment",
    stockTakes: "Stock Takes",
    newStockTake: "New Stock Take",
    updateStockTake: "Update Stock Take",
    transferReturns: "Transfer Returns",
    newTransferReturn: "New Transfer Return",
    updateTransferReturn: "Update Transfer Return",
    transferRequisitions: "Transfer Requisitions",
    newTransferRequisition: "New Transfer Requisition",
    updateTransferRequisition: "Update Transfer Requisition",
    retailPrescriptions: "Retail Prescriptions",
    newRetailPrescription: "New Retail Prescription",
    updateRetailPrescription: "Update Retail Prescription",

    transporters: "Transporters",
    newTransporter: "New Transporter",
    updateTransporter: "Update Transporter",
    tripOrders: "Delivery Trips",
    newTrip: "New Delivery Trip",
    updateTrip: "Update Delivery Trip",
    pickOrders: "Pick Orders",
    newPickOrder: "New Pick Order",
    updatePickOrder: "Update Pick Order",
    containers: "Containers",
    newContainer: "New Container",
    updateContainer: "Update Container",
    groupAdministrators: "Administrator Groups",
    groupNewAdministrator: "New Administrator Group",
    groupUpdateAdministrator: "Update Administrator Group",
    groupCustomers: "Customer Groups",
    groupNewCustomer: "New Customer Group",
    groupUpdateCustomer: "Update Customer Group",
    groupSuppliers: "Supplier Groups",
    groupNewSupplier: "New Supplier Group",
    groupUpdateSupplier: "Update Supplier Group",
    roles: "Roles",
    newRole: "New Role",
    updateRole: "Update Role",
    businesses: "Businesses",
    newBusiness: "New Business",
    updateBusiness: "Update Business",
    locations: "Locations",
    newLocation: "New Location",
    updateLocation: "Update Location",
    countries: "Countries",
    updateCountry: "Update Country",
    injectionProps: "Injection Props",
    newInjectionProp: "New Injection Prop",
    shippingRates: "Shipping Rates",
    newShippingRate: "New Shipping Rate",
    updateShippingRate: "Update Shipping Rate",
    shippingRules: "Shipping Rules",
    newShippingRule: "New Shipping Rule",
    updateShippingRule: "Update Shipping Rule",
    userApiKeys: "User API Keys",
    updateUserApiKey: "Update User API Key",
    newUserApiKey: "New User API Key",

    customFields: "Custom Fields",
    newCustomField: "New Custom Field",
    updateCustomField: "Update Custom Field",

    selectOnly1Location: "Select Only (1) Location",
    youHaveToSelectAnyoneOfTheWarehouseLocationToProceed: "You have to select anyone of the warehouse location to proceed",

    unit: 'UNIT',
    box: 'BOX',
    pallet: 'PALLET',
    wooden: 'WOODEN',
    long: 'LONG',

    // ------ Item -----
    model: "Model",
    itemName: "Item Name",
    price: "Price",
    unitPrice: "Unit Price",
    length: "Length",
    width: "Width",
    height: "Height",
    weight: "Weight",
    cbm: "Cbm",

    // ------ Listing ------
    createdAt: `Created At`,
    createdBy: `Created By`,
    createdDateTime: "Created Date Time",
    updatedAt: `Updated At`,
    updatedBy: `Updated By`,
    updatedDateTime: "Updated Date Time",

    // ------ Button, Radio Button Action, Drop Down ------
    enabled: "Enabled",
    disabled: "Disabled",
    remove: "Remove",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    approved: "Approved",
    back: "Back",
    paymentType: "Payment Type",
    saveChanges: "Save Changes",
    billing: "Billing",
    shipping: "Shipping",
    next: "Next",
    new: "New",
    createNew: "Create New",
    add: "Add",
    search: "Search",
    confirmSearch: "Confirm Search",
    number: "No.",
    category: 'Category',

    // ---------Search UI---------
    selectCustomer: "Select Customer",
    selectSupplier: "Select Supplier",
    selectMember: "Select Member",
    selectLocations: "Select Locations",
    searchCustomer: "Search Customer",
    searchAdministrator: "Search Administrator",
    searchSupplier: "Search Supplier",
    searchRetailMember: "Search Retail Member",
    searchMember: "Search Member",
    searchItems: "Search Items",
    searchKeyword: "Search Keyword",
    selected1Item: "Selected (1) item",
    searchDocuments: "Search Documents",
    selectContainer: "Select Container",
    searchContainers: "Search Containers",

    // -----------Permission---------
    manageItems: "Manage Items",

    // ----------Identity Card UI & Update Profile---------
    credential: "Credential",
    accessAuthentication: "Access Authentication",
    profile: "Profile",
    updateProfile: "Update Profile",
    fullDetailsOfAdministratorInformation: "Full Details of Administrator Information",
    locationPermissions: "Location Permissions",
    dataAccessScopes: "Data Access Scopes",
    changePassword: "Change Password",
    changeCredential: "Change Credential",
    verifyAccountOwnership: "Verify account ownership",

    // -----Custom Field-----
    customProperties: "Custom Properties",
    provideCustomItemInformation: "Provide custom item information",
    properties: "Properties",
    detailSettingsOfTheCustomField: "Detail settings of the custom field",

    key: "Key",
    module: "Module",
    yes: "Yes",
    no: "No",
    function: "Function",
    label: "Label",
    nameLowercaseOnly: "Name (Lowercase Only)",
    displayLabel: "Display Label",
    functionType: "Function Type",
    moduleType: "Module Type",
    inputs: "Inputs",
    inputSettingsOfTheCustomField: "Input settings of the custom field",
    inputType: "Input Type",
    basicSettings: "Basic Settings",
    advancedSettings: "Advanced Settings",
    customSettings: "Others",

    routeAdmin: `Admin`,
    routeWorkstation: `Workstation`,
    routeDriver: `Driver`,
    routeCustomer: `Customer`,
    routeRetail: `Retailer`,
    routeMember: `Member`,

    dateFilter: 'Date Filter',
    fromDate: 'From Date',
    toDate: 'To Date',
    apply: 'Apply'
};